const getters = {
  totalAmount: (state) => state.items.reduce((prev, item) => item.product.price * item.quantity + prev, 0),
  itemsCount: (state) => state.items.reduce((prev, item) => item.quantity + prev, 0),
};

export default getters;
